import BaseLogger from '../log/Logger';
import logger from '../log';
import { safeGet, safeSave } from '../util/storage';

const log = logger.getLogger(__filename) as BaseLogger;

export interface NetworkData {
  externalIps?: string[];
  internalIps?: string[];
  internalMdns?: string | undefined;
}

const key = 'ksdk::common::locality::networkData';
const error = 'network data';
const args = { default: {}, error, key, log };

export function setNetworkData(data: NetworkData): void {
  safeSave({ ...args, data });
}

export function getNetworkData(): NetworkData {
  return safeGet(args) || args.default;
}
